import axios from "axios";

export const client = axios.create({
  baseURL: "https://back-mena.onrender.com/" 
});